/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
import type { Status } from './Status.js';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status.js';

/**
 * Notification
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * id of notification
     * @type {string}
     * @memberof Notification
     */
    id?: string;
    /**
     * Type of notification to be sent to the user
     * @type {string}
     * @memberof Notification
     */
    resourceType?: string;
    /**
     * Sub grouping of the notification
     * @type {string}
     * @memberof Notification
     */
    subGroup?: string;
    /**
     * Created date
     * @type {Date}
     * @memberof Notification
     */
    createdAt?: Date | null;
    /**
     * Created by the system?
     * @type {string}
     * @memberof Notification
     */
    createdBy?: string;
    /**
     * Description text of the notification
     * @type {string}
     * @memberof Notification
     */
    subject?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Notification
     */
    locations?: Array<string>;
    /**
     * Unique identifier the notification refers to
     * @type {string}
     * @memberof Notification
     */
    resourceId?: string;
    /**
     * 
     * @type {Status}
     * @memberof Notification
     */
    status?: Status;
    /**
     * Account number of the notification
     * @type {string}
     * @memberof Notification
     */
    accountNumber?: string;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'resourceType': !exists(json, 'resource_type') ? undefined : json['resource_type'],
        'subGroup': !exists(json, 'sub_group') ? undefined : json['sub_group'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'locations': !exists(json, 'locations') ? undefined : json['locations'],
        'resourceId': !exists(json, 'resource_id') ? undefined : json['resource_id'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'accountNumber': !exists(json, 'account_number') ? undefined : json['account_number'],
    };
}

export function NotificationToJSON(value?: Notification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_type': value.resourceType,
        'sub_group': value.subGroup,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'subject': value.subject,
        'locations': value.locations,
        'resource_id': value.resourceId,
        'status': StatusToJSON(value.status),
        'account_number': value.accountNumber,
    };
}

